import { SEGMENT_BUILDER_TOUR } from "./segmentBuilderTour";
import { useSegmentTourPromo } from "./useSegmentTourPromo";

import { TourPromoBanner } from "@/features/tours/components/TourPromoBanner";

export function SegmentTourBanner() {
  const { showBanner, dismissBanner, startTour } = useSegmentTourPromo();

  if (!showBanner) return null;

  return (
    <TourPromoBanner
      copyKey={`${SEGMENT_BUILDER_TOUR.copyKey}.banner`}
      onStart={startTour}
      onDismiss={dismissBanner}
    />
  );
}
